export default __webpack_public_path__ + "static/media/question-circle.d21e0e08.svg";